"use strict";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".doctors").forEach((container) => {
        const tabs = container.querySelectorAll('.categories__item');
        const panels = container.querySelectorAll('.tabs__item');
        const select = container.querySelector('.categories__select');

        container.querySelectorAll(".doctor-slider").forEach((sliderEl) => {
            new Swiper(sliderEl, {
                modules: [Navigation, Pagination],
                slidesPerView: "auto",
                spaceBetween: 0,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: sliderEl.querySelector('.arrows-next'),
                    prevEl: sliderEl.querySelector('.arrows-prev'),
                }
            });
        });

        function switchTab(targetPanelId) {
            tabs.forEach((t) => {
                const isSelected = t.getAttribute("aria-controls") === targetPanelId;
                t.classList.toggle("active", isSelected);
                t.setAttribute("aria-selected", isSelected ? "true" : "false");
                t.setAttribute("tabindex", isSelected ? "0" : "-1");
            });

            panels.forEach((p) => {
                p.classList.toggle("active", p.id === targetPanelId);
            });

            if (select && select.value !== targetPanelId) {
                select.value = targetPanelId;
            }

            const targetPanel = container.querySelector(`#${targetPanelId}`);
            if (targetPanel) {
                const panelSwiper = targetPanel.querySelector('.doctor-slider');
                if (panelSwiper && panelSwiper.swiper) {
                    panelSwiper.swiper.update();
                }
            }
        }

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const targetPanelId = tab.getAttribute("aria-controls");
                switchTab(targetPanelId);
            });

            tab.addEventListener("keydown", (e) => {
                let index = Array.from(tabs).indexOf(tab);

                if (e.key === "ArrowRight") {
                    e.preventDefault();
                    index = (index + 1) % tabs.length;
                    tabs[index].focus();
                    tabs[index].click();
                } else if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    index = (index - 1 + tabs.length) % tabs.length;
                    tabs[index].focus();
                    tabs[index].click();
                } else if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
                    e.preventDefault();
                    tab.click();
                }
            });
        });

        if (select) {
            select.addEventListener("change", (e) => {
                switchTab(e.target.value);
            });
        }
    });
});